import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Pipe, PipeTransform } from '@angular/core';

export class ProtocoloArquivo extends BaseEntity {
    public id: number;
    public idProtocoloNegocio: string;
    public tipoProtocolo: string;
    public statusProtocolo: string;
    public cnpjAgente: string;
    public dataEnvio: Date;
    public usuarioEnvio: string;
    public origemProtocolo: string;
    public ordemDecrescenteEnvioPorTipoAgenteModalidadeStatus: number;  // 1 representa o protocolo mais recente deste tipo para este agenteModalidade por status, 2 é o segundo mais recente, e assim por diante
    public tamanhoConteudoEnvio: number;
    public tamanhoConteudoResposta: number;
    public conteudoRespostaContemMensagemAlerta: boolean;
    public apenasValidacao: boolean;
    public siglaAgente: string;
    public nomeAgente: string;
    public usuarioSubstituicao: string;
    public dataSubstituicao: Date;

}
export class ProtocoloConsultaImpedimento extends BaseEntity {
  public id: number;
  public identificadorProtocoloNegocio: string;
  public tipoConsultaProtocolo: string;
  public statusConsultaProtocolo: string;
  public cnpjAgente: string;
  public dataEnvio: Date;
  public usuarioEnvio: string;
  public origemProtocolo: string;
  public ordemDecrescenteEnvioPorTipoAgenteModalidadeStatus: number;  // 1 representa o protocolo mais recente deste tipo para este agenteModalidade por status, 2 é o segundo mais recente, e assim por diante
  public tamanhoConteudoEnvio: number;
  public tamanhoConteudoResposta: number;
  public conteudoRespostaContemMensagemAlerta: boolean;
  public apenasValidacao: boolean;
  public siglaAgente: string;
  public nomeAgente: string;

}

export enum StatusProtocolo {
    AGUARDANDO_VALIDACAO = 'A',
    ERRO = 'E',
    SUCESSO = 'S',
    SUBSTITUIDO = 'R',
    CANCELADO = 'C'
  }

  export const STATUS_PROTOCOLO = [
  {
    codigo: 'A',
    label: 'Aguardando validação'
  },
  {
    codigo: 'E',
    label: 'Erro'
  },
  {
    codigo: 'S',
    label: 'Sucesso'
  },
  {
    codigo: 'R',
    label: 'Substituído'
  },
  {
    codigo: 'C',
    label: 'Cancelado'
  }
];

export class JanelaEnvioProtocolo extends BaseEntity {
	public dataAbertura: Date;
  public dataFechamento: Date;
  public dataInicioProcessamento: Date;
  public nomeJanela: String;
}


export const TIPO_PROTOCOLO = [
  {
    codigo: '1',
    descricao: 'Operações'
  },
	{
    codigo: "2",
    descricao: "Liberações posteriores"
  },
  {
    codigo: "3",
    descricao: "Solicitações de honra"
  },
  {
    codigo: "4",
    descricao: "Recuperações de crédito"
  },
  {
    codigo: "5",
    descricao: "Amortizações antecipadas",
  },
  {
    codigo: "6",
    descricao: "Atualização de Risco",
  },
  {
    codigo: "7",
    descricao: "Posição da Carteira em Recuperação de Crédito",
  }

];
